import { useCallback } from "react";
import { AnalyticsApi, useAPIAction } from "melco-shared-logic";

export const useUserActive = (startTimeStamp: any, endTimeStamp: any, productCode: any) => {


    const [getUserData] = useAPIAction(AnalyticsApi,
        async (api) => {
            const data = await api.analyticsGetActiveUsers({
                startDate: startTimeStamp,
                endDate: endTimeStamp,
                productCode: productCode

            });

            console.log(data)
            console.log(JSON.stringify(data))
            return {
                successMessages: [],
                data,
            };
        },
        {
            //defaultApiConfigOptions: { impersonationForId: currentUser?.userId },
            translationPrefix: "",
        }
    );

    return useCallback(
        async () => {
            try {
                const res = await getUserData();
                console.log(res);
                return res;
            }
            catch (e) {
                // exception already handled in useAPIAction
            }
        },
        [getUserData]
    );

}





